import * as z from "zod";
import { userFacingError } from "../authorization";
import { mutator } from "./mutator";

// The requester withdrawing their own pending request.
export const cancelGrantRequest = mutator({
  schema: z.object({ requestId: z.string() }),
  resolve: {
    request: { kind: "grantRequest", from: "requestId" },
  },
  permissions: {
    none: "the requester withdraws their own request; ownership is checked in fn",
  },
  fn: async ({ tx, ctx, args: { request } }) => {
    if (request.requestedByUserId !== ctx.userId) {
      throw userFacingError("Share request not found");
    }

    await tx.mutate.grantRequests.delete({ id: request.id });
  },
});
